<template>
  <Dialog
    v-model:visible="localVisible"
    modal
    :header="header"
    :style="{ width: '20rem' }"
    :closable="true"
    @hide="onClose"
  >
    <div class="flex flex-col gap-3">
      <Button
        class="w-full justify-start gap-3"
        severity="secondary"
        outlined
        @click="selectSource('camera')"
      >
        <i class="pi pi-camera text-xl" />
        <span>Take Photo</span>
      </Button>
      <Button
        class="w-full justify-start gap-3"
        severity="secondary"
        outlined
        @click="selectSource('gallery')"
      >
        <i class="pi pi-images text-xl" />
        <span>Choose from Gallery</span>
      </Button>
    </div>
  </Dialog>
</template>

<script>
  import { defineComponent, ref, watch } from "vue";

  export default defineComponent({
    name: "MediaSourceDialog",
    props: {
      visible: {
        type: Boolean,
        required: true
      },
      header: {
        type: String,
        default: "Select Source"
      }
    },
    emits: ["update:visible", "select"],
    setup(props, { emit }) {
      const localVisible = ref(props.visible);

      // Watch the visible prop and update localVisible accordingly
      watch(
        () => props.visible,
        (newVal) => {
          localVisible.value = newVal;
        }
      );

      // Watch localVisible and emit changes to the parent
      watch(
        () => localVisible.value,
        (newVal) => {
          emit("update:visible", newVal);
        }
      );

      const closeDialog = () => {
        localVisible.value = false;
      };

      const selectSource = (source) => {
        emit("select", source);
        closeDialog();
      };

      const onClose = () => {
        emit("update:visible", false);
      };

      return {
        localVisible,
        selectSource,
        onClose
      };
    }
  });
</script>
